import React from 'react';
import numberWithCommas from '../../utils/numberFormat';
import { ADD_FRIEND } from '../../constants/ModalTypes';
import ProfileImage from '../../components/ProfileImage';

const renderProfileImage = (profileImage, profilePath) => {
  if (!profileImage) {
    return (
      <div className="wrap_thumb">
        <a href={profilePath}>
        </a>
      </div>
    );
  }

  return (
    <div className="wrap_thumb">
      <a href={profilePath}>
        <ProfileImage image={profileImage} sizeType="small" />
      </a>
    </div>
  );
};

const ProfileBanner = ({ 
  profile: { name, statusMessage, friendCount, profileImage },
  post,
  device,
  showModal
}) => {

  const splited = post.permalink.split('/');
  const profilePath = `/${splited.slice(3, 4)}`;
  const osName = device.getIn(['os', 'name']);

  return (
    <div className="box_profile">
      { renderProfileImage(profileImage, profilePath) }
      <div className="post_info">
        <div className="inner_info">
          <strong className="txt_name"><a href={profilePath}>{name}</a></strong>
          { statusMessage !== '' && (<span className="txt_info">{statusMessage}</span>) }
          { friendCount > 0 && (<span className="txt_friend">친구 <span className="num_friend">{numberWithCommas(friendCount)}</span>명</span>) }
          <button type="button" className="btn_add"
            onClick={() => (osName !== 'Android' && osName !== 'iOS')
              ? alert('채널 추가는 카카오톡 모바일앱에서 가능합니다.')
              : showModal(ADD_FRIEND, { post, device })}>
            <span className="inner_txt">채널 추가</span>
          </button>
        </div>
      </div>
    </div>
  );
}
export default ProfileBanner;



// WEBPACK FOOTER //
// ./src/components/PostBox/ProfileBanner.js